import axios from 'axios';
import vuetify from '../../plugins/vuetify';

export default {
  state: {
    tequsDocument: {
      info: {},
    },
    questionList: [],
    contentLoaded: false,
  },
  mutations: {
    START_TEST(state) {
      state.start_test = true;
    },
    ANSWER_QUESTION(state, payload) {
      state.questionList = payload;
    },
    SET_TEQUS_DOCUMENT(state, payload) {
      state.tequsDocument = payload;
    },
    SET_QUESTIONS(state, payload) {
      state.questionList = payload;
    },
    TEST_LOADED(state) {
      state.contentLoaded = true;
    },
    THEME_SETUP(state) {
      const theme_data = state.tequsDocument.info.theme;
      // console.log('vue', vuetify);
      if (theme_data.theme_setup.darkTheme) {
        vuetify.framework.theme.dark = true;
        vuetify.framework.theme.themes.dark = theme_data.theme_setup.color;
      } else {
        vuetify.framework.theme.themes.light = theme_data.theme_setup.color;
      }
    },
  },
  actions: {
    startTest(context) {
      // https://tequs-api-definition.herokuapp.com/
      context.commit('START_TEST');
    },
    fetchTequsDocument(context, { tqId, langId }) {
      return (
        axios
          // .get('http://localhost:3000/tequsDocument/' + tequsDocumentId)
          .get('http://oblak.bitwork.rs:8080/api/tqsfront/' + tqId + '/' + langId)
          .then(data => {
            // console.log('podaci', data.data.tqs_global);
            context.commit('SET_TEQUS_DOCUMENT', data.data.tqs_global);
            context.commit('SET_QUESTIONS', data.data.questionList);
            context.commit('THEME_SETUP');
            context.commit('TEST_LOADED');
          })
          .catch(function(error) {
            if (error.response) {
              // Request made and server responded
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // The request was made but no response was received
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
          })
      );
    },
  },
  namespaced: true,
};
